import {isEmpty, reject} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

export const getUserName = <T extends {lastName?: string | Nullish; firstName?: string | Nullish}>(
  user: T | Nullish,
  {reverse = false}: {reverse?: boolean} = {}
) => {
  const nameArray = reject(isNilOrEmpty, [user?.lastName, user?.firstName]);

  if (isEmpty(nameArray)) {
    return null;
  }

  if (reverse) {
    return nameArray.toReversed().join(' ');
  }

  return nameArray.join(' ');
};
